// extracted by mini-css-extract-plugin
export default {"WeightBlock":"WeightBlock_WeightBlock__XcS-6","toggled":"WeightBlock_toggled__A17IE"};